import React from 'react';
import { Helmet } from "react-helmet-async";
import { useI18n } from "../../i8n/useI18n";
import HeroSection from "../sections/home/hero/HeroSection";
import CategoriesSection from "../sections/home/categories/CategoriesSection";
import BlogTeaserSection from "../sections/home/blogTeaser/BlogTeaserSection";
import ProductHighlightsSection from "../sections/home/productHighlights/ProductHighlightsSection";
import NewsletterSection from "../sections/home/newsletter/NewsletterSection";
import EditorialSection from "../sections/home/editorial/EditorialSection";

const HomePage = () => {
    const { t } = useI18n();
    return (
        <>
            <Helmet>
                <title>{t("brand.name")} | {t("brand.claim")}</title>
                <meta name="description" content={t("home.heroSection.subtitle")} />
            </Helmet>
            <HeroSection />
            <ProductHighlightsSection />
            <EditorialSection
                variant="image"
                imageFirst
                imagePhotoId="photo-1779676086517-8e95203d3dde"
                eyebrow={t("home.editorialSection.brandStory.eyebrow")}
                title={t("home.editorialSection.brandStory.title")}
                body={t("home.editorialSection.brandStory.body")}
            />
            <CategoriesSection />
            <EditorialSection
                variant="typographic"
                eyebrow={t("home.editorialSection.philosophy.eyebrow")}
                title={t("home.editorialSection.philosophy.title")}
                body={t("home.editorialSection.philosophy.body")}
            />
            <EditorialSection
                variant="image"
                imagePhotoId="photo-1701789575034-9cd42d2dfd0a"
                eyebrow={t("home.editorialSection.finalStatement.eyebrow")}
                title={t("home.editorialSection.finalStatement.title")}
                body={t("home.editorialSection.finalStatement.body")}
            />
            <BlogTeaserSection />
            <NewsletterSection />
        </>
    );
};

export default HomePage;
